import School from '../school';

/**
 * Create the action
 */

const { thunk, request, success, error } = School.index((fetch) =>
    fetch.get('school')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
